module.exports = __webpack_public_path__ + "img/font-underline.74ff1e1b.svg";